module.exports = __webpack_public_path__ + "static/media/competency template.f3059a84.xlsx";